import { certificateMiddle } from 'documents/certificate.middle';
import { appendixMiddle } from 'documents/appendix.middle';
import { reportMiddle } from 'documents/report.middle';

import { certificateHigh } from 'documents/certificate.high';
import { appendixHigh } from 'documents/appendix.high';
import { reportHigh } from 'documents/report.high';

const Document = (type, parameters = {}, ...data) => {
	switch (type) {
	case 'certificate-middle':
		return certificateMiddle(parameters, ...data);
	case 'appendix-middle':
		return appendixMiddle(parameters, ...data);
	case 'report-middle':
		return reportMiddle(parameters, ...data);
	case 'certificate-high':
		return certificateHigh(parameters, ...data);
	case 'appendix-high':
		return appendixHigh(parameters, ...data);
	case 'report-high':
		return reportHigh(parameters, ...data);
	default:
		console.warn('Undefined document type');
	}
};

export default Document;